import React, { useState, useEffect } from "react";

import {
  TextField, Button, Checkbox,  Dialog,
  DialogActions, DialogContent, DialogTitle,
  Slide, IconButton, Autocomplete, Paper,
  Table, TableBody, TableContainer, TableHead, TableRow,
} from "@mui/material";

import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useForm, Controller, useWatch } from "react-hook-form";
import { useAppDispatch, useAppSelector } from "../../provider/app/hooks";
import { obtenerSesion , crearInvitacion, obtenerListadoInvitaciones} from "../../service/apiService";
import { setItems as setInvitacionsItem } from "../../provider/Slice/InvitationSlice";

import {
  AddButton, StyledTableRow,
  StyledTableCell, InputStyle,
  CheckBox, StyleTableSortLabel
} from "../../SXStyle";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function DialogInvitationGroup({ open, setOpen, setSnackbar, registroSeleccionado }) {
  
  const usuarios = useAppSelector((state) => state.StoreUsuarios.data);

  const grupos = useAppSelector((state) => state.StoreGrupos.data);
  
  const [groupSelected, setSelectedGroup] = useState([]);
  const [usersSelected, setSelectedUsers] = useState([]);
  const cacheUsuario = JSON.parse(localStorage.getItem('sesionIniciada'));
  

  const dispatch = useAppDispatch();

  //react-hook-form
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {},
  });

  //guarda el registro
  const onSubmit = async (data) => {

    if(usersSelected.length == 0)
    {
      setSnackbar({ message: "Seleccione al menos un usuario para enviar la invitación", open: true });
      return;
    }

    if(groupSelected.length == 0)
    {
      setSnackbar({ message: "Seleccione al menos un grupo para invitar al usuario", open: true });
      return;
    }

    let invitations = [];

    usersSelected.forEach((item) => {
      let user = item.id;
      let email = item.email;

      groupSelected.forEach((subItem) => {
        let group = subItem.id;

        invitations.push({
          user: user,
          group: group,
          status: 0,
          email: email,
          description: data.description,
          invited_by : cacheUsuario.id
        })
      })
    })

    let request = {"invitations" : invitations}

    let result = await crearInvitacion(request);

    if(result)
    {
      //recarga el listado
      const result2 =  await obtenerListadoInvitaciones();
      dispatch(setInvitacionsItem(result2.data));
      setSnackbar({ message: "Se han enviado las invitaciones pertinentes", open: true });
    }
    else if (!result)
    {
      setSnackbar({ message: "Algo ha salido mal , intentelo de nuevo", open: true });
    }

    //limpia los datos despues de mandar una solicitud
    reset();
    setSelectedGroup([]);
    setSelectedUsers([]);

    handleDialogClose();
  };

  //watch del usuario seleccionado
  const usuarioSeleccionado = useWatch({
    control,
    name: "name",
    defaultValue: "",
  });

  //autocompleta el email del usuario seleccionado
  useEffect(() => {
    if (usuarioSeleccionado != null && open)
      setValue("email", usuarioSeleccionado.email);
    else setValue("email", "");
  }, [usuarioSeleccionado, open]);


  //grupos seleccionados
  useEffect(() => {
   
    if(groupSelected.length > 0 && open)
    {
      let string = groupSelected.map(item => item.name).join(" , ");
      setValue("description", cacheUsuario.fullname + " te ha invitado a que crees una cuenta en Geosoftsolutions para los siguientes proyectos: " + string  ); // solo cambia email    
    }
    else
    {
      setValue("description", " ");
    }

  }, [groupSelected, open])

  //selecciona automaticamente el grupo
  useEffect(() => {
    if(registroSeleccionado !== null && open )
    {
      registrarGrupo(registroSeleccionado)
    }
  }, [registroSeleccionado, open])


  //cierra el dialog
  const handleDialogClose = () => {
     //limpia los datos despues de mandar una solicitud
    reset();
    setSelectedGroup([]);
    setSelectedUsers([]);
    
    setOpen(false);
  };

  //selecciona un grupo
  const registrarGrupo = (id) => {
    const grupoSeleccionado =  grupos.find((item) => item.id == id)

    setSelectedGroup((oldArray) => {
      const existe = oldArray.some((item) => item.id === id);
      if (existe)
        return oldArray.filter((item) => !(item.id === id)); // Elimina si ya existe
      else
        return [...oldArray, grupoSeleccionado]; // Agrega si no existe
    })
  };

  //selecciona los usuarios a los que se les mandara la invitacion
  const seleccionarUsuario = () => {
    if(usuarioSeleccionado != null)
    {
        setSelectedUsers((oldArray) => {
        const existe = oldArray.some((item) => item === usuarioSeleccionado.id);
        if (existe)
          return oldArray.filter((item) => !(item === usuarioSeleccionado.id)); // Elimina si ya existe
        else
          return [...oldArray, usuarioSeleccionado]; // Agrega si no existe
      })
    }
  }

  return (
    <React.Fragment>
      
      <Dialog
        open={open}
        slots={{
          transition: Transition,
        }}
        keepMounted
        onClose={handleDialogClose}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          sx: {
            backgroundColor: "#555b5e",
            border: "1px solid",
            borderRadius: "10px",
            borderColor: "#555b5e",
            maxHeight: "500px"
          },
        }}
      >
        <DialogTitle>
          <div className="flex"> 
            <p className="text-white font-bold"> Invitar Usuarios </p>

            <div className="ml-[65%] cursor-pointer"> 
              <ManageHistoryIcon className="text-blanco" sx={{fontSize: "28px" }}/>
            </div>
          </div>
        </DialogTitle>

        <DialogContent>
          <form
            id="mi-formulario"
            className="space-y-4 md:space-y-6"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="flex gap-3">

              <Controller
                name="name"
                control={control}
                rules={{ required: "Campo faltante o inválido" }}
                render={({ field: { onChange, value, ref } }) => (
                  <Autocomplete
                    disablePortal
                    options={usuarios}
                    getOptionLabel={(option) => option.fullname || ""}
                    value={value || null} // valor seleccionado
                    onChange={(_, newValue) => onChange(newValue)} // actualiza react-hook-form
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Recipients"
                        inputRef={ref} // referencia para react-hook-form (opcional)
                        className="rounded-lg block w-full bg-inputs border"
                        sx={{
                          ...InputStyle,
                          marginTop: "10px",
                          width: "240px",
                        }}
                        error={!!errors.name}
                        helperText={errors.name?.message}
                      />
                    )}
                  />
                )}
              />

              <Controller
                name="email"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Email"
                    className="rounded-lg block w-full bg-inputs border"
                    sx={{
                      ...InputStyle,
                      marginTop: "10px",
                      width: "280px",
                      pointerEvents: "none",
                    }}
                  />
                )}
              />

              <IconButton onClick={() => seleccionarUsuario()}>
                <AddCircleOutlineIcon className="text-gris" sx={{fontSize: "30px"}} />
              </IconButton>
            </div>

            <div className="mt-2">
              {usersSelected.length > 0 && (
                <> 
                  <p className="text-white text-[13px]"> Se enviarán los siguientes correos a: </p>
                  <ul className="text-[13px]">
                    {usersSelected.map((item) => (
                      <li className="flex gap-3 mt-2 ml-3">
                        <AccountCircleIcon className="text-amarillo"/> 
                        <p className="text-white"> 
                          { item.fullname} - { item.email}
                        </p>
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </div>

            {/* Tabla */}
            <div>
              <TableContainer
                component={Paper}
                sx={{  width: "100%", marginTop: "20px" }}
              >
                <Table aria-label="customized table" stickyHeader>
                  <TableHead>
                    <TableRow>
                       <StyledTableCell align="center">
                        
                      </StyledTableCell>
                    
                      <StyledTableCell align="center">
                        Id
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        Nombre
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {grupos?.map((row, index) => {
                      const isItemSelected = groupSelected.some(obj => obj.id === row.id);
                      const labelId = `enhanced-table-checkbox-${index}`;
                      return (
                        <StyledTableRow 
                          hover
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.id}
                          sx={{ cursor: 'pointer' }}
                        >
                          <StyledTableCell align="center" style={{pointerEvents: "none"}}>
                           <Checkbox
                              color="primary"
                              checked={isItemSelected}
                              sx={{...CheckBox, width: "12px", height: "12px"}}
                              inputProps={{
                                'aria-labelledby': labelId,
                              }}
                            />
                          </StyledTableCell>

                          <StyledTableCell align="center">
                            {row.id}
                          </StyledTableCell>

                          <StyledTableCell align="center">
                            {row.name}
                          </StyledTableCell>
                        </StyledTableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>

            <Controller
              name="description"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Descripción"
                  className="rounded-lg block w-full bg-inputs border"
                  sx={{ ...InputStyle, marginTop: "10px" }}
                  multiline
                  rows={2}
                />
              )}
            />

          </form>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleDialogClose}>
            <p className="text-rojo"> Cancelar </p>
          </Button>
          <Button type="submit" form="mi-formulario" >
            <p className="text-amarillo"> Aceptar </p>
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default DialogInvitationGroup;
